export default __webpack_public_path__ + "static/media/LightingFix3.63520555.jpg";